/*@ngInject*/
const NotificationPopupUtil = function (Notification) {

    this.displayNotificationPopup = function ($scope) {
        return Notification.info({
            templateUrl: '/ui/notification/notificationGrowl/notificationGrowlComponent.tpl.html',
            scope: $scope,
            positionX: 'center',
        });
    };

    this.displayChatNotification = function ($scope) {
        return Notification.info({
            templateUrl: '/ui/notification/growl/growlComponent.tpl.html',
            scope: $scope
        });
    };
};

angular.module('umCore')
    .service('notificationPopupUtil', NotificationPopupUtil);

